import { render } from "./recapitulatif.vue?vue&type=template&id=8a1183b4&scoped=true"
import script from "./recapitulatif.vue?vue&type=script&lang=js"
export * from "./recapitulatif.vue?vue&type=script&lang=js"

import "./recapitulatif.vue?vue&type=style&index=0&id=8a1183b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1183b4"]])

export default __exports__